"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
function getLocalize() {
    if (typeof Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return Localize;
}
;
/* istanbul ignore next */
function getLocalizeFormat() {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
}
/* istanbul ignore next */
exports.LocaleData = { get: function () { return getLocalizeFormat().localeData; } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    AllConnectionTypes: function () { return t('@tableau__workbook-templates-widgets/AllConnectionTypes'); },
    AvailableDeviceLayoutsLaptop: function () { return t('@tableau__workbook-templates-widgets/AvailableDeviceLayoutsLaptop'); },
    AvailableDeviceLayoutsPhone: function () { return t('@tableau__workbook-templates-widgets/AvailableDeviceLayoutsPhone'); },
    AvailableDeviceLayoutsTablet: function () { return t('@tableau__workbook-templates-widgets/AvailableDeviceLayoutsTablet'); },
    CreatingExtractDialogTitle: function () { return t('@tableau__workbook-templates-widgets/CreatingExtractDialogTitle'); },
    CreatingExtractDialogSensitiveDataMessage: function () { return t('@tableau__workbook-templates-widgets/CreatingExtractDialogSensitiveDataMessage'); },
    CreatingExtractDialogMessage: function () { return t('@tableau__workbook-templates-widgets/CreatingExtractDialogMessage'); },
    CreatingExtractDialogSensitiveDataLink: function () { return t('@tableau__workbook-templates-widgets/CreatingExtractDialogSensitiveDataLink'); },
    CreatingWorkbookDialogTitle: function () { return t('@tableau__workbook-templates-widgets/CreatingWorkbookDialogTitle'); },
    CreatingWorkbookDialogMessage: function () { return t('@tableau__workbook-templates-widgets/CreatingWorkbookDialogMessage'); },
    DatasourceHeaderMessage: function () { return t('@tableau__workbook-templates-widgets/DatasourceHeaderMessage'); },
    LayoutsHeaderMessage: function () { return t('@tableau__workbook-templates-widgets/LayoutsHeaderMessage'); },
    MoreLikeThis: function () { return t('@tableau__workbook-templates-widgets/MoreLikeThis'); },
    SelectProjectCancel: function () { return t('@tableau__workbook-templates-widgets/SelectProjectCancel'); },
    SelectProjectNameLabel: function () { return t('@tableau__workbook-templates-widgets/SelectProjectNameLabel'); },
    SelectProjectOk: function () { return t('@tableau__workbook-templates-widgets/SelectProjectOk'); },
    SelectProjectProjectLabel: function () { return t('@tableau__workbook-templates-widgets/SelectProjectProjectLabel'); },
    SelectProjectTitle: function () { return t('@tableau__workbook-templates-widgets/SelectProjectTitle'); },
    SelectTemplateButtonText: function () { return t('@tableau__workbook-templates-widgets/SelectTemplateButtonText'); },
    SignInToConnectionTypeButtonText: function (a) { return t('@tableau__workbook-templates-widgets/SignInToConnectionTypeButtonText', a); },
    TemplateDescriptionUseSampleDataButtonTitle: function (a) { return t('@tableau__workbook-templates-widgets/TemplateDescriptionUseSampleDataButtonTitle', a); },
    TemplateDescriptionSignInToButtonTitle: function (a) { return t('@tableau__workbook-templates-widgets/TemplateDescriptionSignInToButtonTitle', a); },
    TemplateThumbnailImageButtonTitle: function (a) { return t('@tableau__workbook-templates-widgets/TemplateThumbnailImageButtonTitle', a); },
    TitleLink: function () { return t('@tableau__workbook-templates-widgets/TitleLink'); },
    TitleText: function () { return t('@tableau__workbook-templates-widgets/TitleText'); },
    UseSampleDataButtonText: function () { return t('@tableau__workbook-templates-widgets/UseSampleDataButtonText'); },
    WaitingDialogOk: function () { return t('@tableau__workbook-templates-widgets/WaitingDialogOk'); },
};
//# sourceMappingURL=Localize.js.map